import queryString from 'query-string';
import { createApp } from 'vue';
import globalComponents from '@/components';
import router from './router';
import store from './store';
import directive from './directive';
import App from './App.vue';
import '@/assets/style/global.less';
import '@/api/interceptor';
import ArcoVueIcon from '@arco-design/web-vue/es/icon';
import '@arco-design/web-vue/es/message/style/index.less';
import '@arco-design/web-vue/es/notification/style/index.less';
import '@arco-design/web-vue/es/modal/style/index.less';
import '@arco-design/web-vue/dist/arco.css';
import Vue3DraggableResizable from 'vue3-draggable-resizable';
//需引入默认样式
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css';
import { initVChartArcoTheme } from '@visactor/vchart-arco-theme';
import { createPinia } from 'pinia';
import { getUserTokenByTicket } from './api/bi/user';
import { Message } from '@arco-design/web-vue';
import { setCookie } from './utils';
import { goSSO } from './utils/auth';
import * as Sentry from '@sentry/vue';
const initApp = () => {
  initVChartArcoTheme();

  const app = createApp(App);

  Sentry.init({
    app,
    dsn: 'https://5659203cacd56f5e013f12ee5f1c6b66@sentry.youxi123.com/4',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0
  });
  const pinia = createPinia();
  app.use(pinia);

  app.use(router);
  app.use(store);
  app.use(ArcoVueIcon);
  app.use(Vue3DraggableResizable);
  app.use(globalComponents);
  app.use(directive);
  app.mount('#app');
};
const urlParam = queryString.parse(window.location.search.replace(/\?/g, '&'));
if (urlParam.ticket) {
  if (!urlParam.next) {
    getUserTokenByTicket({
      ticket: urlParam.ticket as string
    })
      .then(res => {
        if (res.data) {
          setCookie('biUserToken', res.data.token);
          let replaceUrl = window.location.href.replace(
            /[?&]ticket=([^&]*)/,
            ''
          );
          window.location.href = replaceUrl;
        } else {
          Message.error({
            content: res.msg || '',
            duration: 2000
          });
        }
      })
      .catch(_err => {
        console.log(_err);
        Message.error({
          content: '获取用户信息失败:' + _err.message,
          duration: 2000,
          onClose: () => {
            if ((_err.status = 401)) {
              goSSO();
            }
          }
        });
      });
  } else {
    window.location.href =
      (urlParam.next as string) + '?ticket=' + urlParam.ticket;
  }
} else {
  initApp();
}
